import React from 'react'
import values from 'mout/object/values'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';
import { SubjectBreakdown } from './'

export default function SubjectBreakdowns ({studentScore, subtests, nodes,}) {
  const subs = sortByPropText(values(subtests), 'displayName')
  return (
    <section className='SubjectBreakdowns'>
      {
        subs.map(subtest => 
          <SubjectBreakdown
            displayName={subtest.displayName}
            nodes={nodes}
            studentScore={studentScore}
            subtest={subtest}
            key={`StSubBkdn${subtest.displayName}`}
          />
        )
      }
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/SubjectBreakdowns.js